import { CommonModule, Location } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ServiceMessageComponent } from '@core/components/service-message/service-message.component';
import { DEFAULT_DIALOG_CONFIG, SereviceMessageType } from '@core/constants/serviceMessage.const';
import { IApp } from '@core/models/app.interfaces';
import { LookupService } from '@core/services/lookup.service';
import { StoreService } from '@core/store/store.service';
import { ObligationManagementService } from '@module/obligation-management/services/obligation-management.service';
import { UnitManagementService } from '@module/unit-management/services/unit-management.service';
import { FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FieldsetAriaFixDirective } from '@shared/directives/fieldset-area-fix.directive';
import { FormService } from '@shared/services/form.service';
import { ModalService } from '@shared/services/modal.service';
import * as moment from 'moment-timezone';
import { DialogModule } from 'primeng/dialog';
import { FieldsetModule } from 'primeng/fieldset';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

export const TRANSLATION_PREFIX = 'OBLIGATION_MGMT_MODULE.ruInvalidForm.';
const DATE_FORMAT = 'YYYY-MM-DD';
export const COMPONENT_ID = 'ASSIGN_181';
export const TRANSLATION_PREFIX_COOMON = 'COMMON.actionsLabel.';

export const actionButtonMap:  any = {
 APPROVE : {
    label : `${TRANSLATION_PREFIX_COOMON}APPROVE`,
    actionUri : '/approve181Obligation',
    id: COMPONENT_ID + '_approveBtn',
    showOnNew: false,
    workflowAction: 'APPROVE',
  },
  REJECT : {
    label : `${TRANSLATION_PREFIX_COOMON}REJECT`,
    actionUri : '/reject181Obligation',
    id: COMPONENT_ID + '_rejectBtn',
    showOnNew: false,
    workflowAction: 'REJECT',
  },
  RESUBMIT : {
    label : `${TRANSLATION_PREFIX_COOMON}RESUBMIT`,
    actionUri : '/resubmit181Obligation',
    id: COMPONENT_ID + '_resubmitBtn',
    showOnNew: false,
    workflowAction: 'RESUBMIT',
  },
  EDIT : {
    label : `${TRANSLATION_PREFIX_COOMON}SUBMIT`,
    actionUri : '/assign181Obligation',
    id: COMPONENT_ID + '_submitBtn',
    showOnNew: false,
    workflowAction: 'SUBMIT',
  },
 };

@Component({
  selector: 'app-recognized-unit-invalidate',
  templateUrl: './recognized-unit-invalidate.component.html',
  styleUrls: ['./recognized-unit-invalidate.component.scss'],
  imports: [DialogModule, FieldsetAriaFixDirective, FieldsetModule, FormlyModule, CommonModule,
    TranslateModule ]
})
export class RecognizedUnitInvalidateComponent  implements OnInit {
  private _destroy$ = new Subject<any>();
  public visible = false;
  public message: string;
  public title: string;
  @Input() type: string;
  @Input() remittanceData: any = {};
  is181: boolean;
  buttons: IApp.ICreditButtonConfig[];
  remittanceFormFields: FormlyFieldConfig[];
  section181FormFields: FormlyFieldConfig[];
  remittanceForm = new FormGroup({});
  section181Form = new FormGroup({});
  obpsAccounts = new BehaviorSubject<IApp.IFacilityNamesLookup[]>(null);
  searchOffsetProjectNames = new BehaviorSubject<IApp.ILookup[]>(null);
  compliancePeriods$ = new BehaviorSubject<IApp.ILookup[]>(null);

  private obligationReasonTypes: any;

 constructor(
    private translate: TranslateService,
    private obligationManagementService: ObligationManagementService,
    private unitManagementService: UnitManagementService,
    private lookupService: LookupService,
    private _location: Location,
    private formService: FormService,
    private modalService: ModalService,
    private store: StoreService,

  ) {}

  ngOnInit() {
    if (this.remittanceData) {
      this.remittanceData = {
        ...this.remittanceData,
        quantity: this.remittanceData.remittanceQuantity || this.remittanceData.quantity,
        quantity_copy: this.remittanceData.remittanceQuantity || this.remittanceData.quantity,
        issuanceYear: this.remittanceData.vintage || this.remittanceData.issuanceYear,
      };
    }
    this.lookupService
      .getCompliancePeriods()
      .pipe(takeUntil(this._destroy$))
      .subscribe((value) => this.compliancePeriods$.next(value));
    this.getFacilityNames();
    this.getProjectNames(null);
    this.visible = true;
    this.is181 = this.type === 'assignObligation';
    if (this.is181) {
      this.setButtonsByActions();
    }
    this.title = this.translate.instant(
      `${TRANSLATION_PREFIX}ruRemittanceForm`,
    );

    this.remittanceFormFields = [
      {
        fieldGroupClassName: 'row',
        fieldGroup: [
          {
            className: 'col-6',
            type: 'input',
            wrappers: ["form-field"],
            key: 'quantity',
            templateOptions: {
              label: `${TRANSLATION_PREFIX}quantity`,
              readOnly: true,
              required: true,
              keypress: (field, event) => {
                if (isNaN(parseInt(event.key, 10))) {
                  event.preventDefault();
                }
              },
              change: (field, $event) => {
                this.remittanceData.quantity_copy = this.remittanceData.quantity;
                this.unitManagementService.validateQuantity(field);
              },
            },
            validators: {
              quantity: {
                expression: c => !(isNaN(c.value) || c.value % 1 !== 0 || +c.value <= 0),
                message: () => this.translate.instant('COMMON.messageSection.quantityMustBePositiveNumber'),
              },
            },
          },

        ],
      },
    ];

    if (this.store.user.isOBPS()) {
    this.section181FormFields = [
      {
        fieldGroupClassName: 'row',
        fieldGroup: [
          {
            className: 'col-6',
            type:  "dict-select" ,
            wrappers: ['form-field'],
            key: 'accountId',
            hideExpression: !this.is181,
            templateOptions: {
              label: `${TRANSLATION_PREFIX}facilityName`,
              required: true,
              source: this.getObpsFacilityNames(),
              change: (field, $event) => {
                if(!$event.initial){
                  this.remittanceData = {
                    ...field.model,
                    accountId:  $event ? $event.id : '',
                    certificateNumber: $event ? $event.certificateNumber : '',
                  };
                }
              },
            },
          },
          {
            className: 'col-6',
            type:  "readonly-input",
            wrappers: ['form-field'],
            key: 'facilityName',
            hideExpression: this.is181,
            templateOptions: {
              label: `${TRANSLATION_PREFIX}facilityName`,
              required: true,
            },
          },
          {
            className: 'col-6',
            type: 'readonly-input',
            wrappers: ['form-field'],
            key: 'certificateNumber',
            templateOptions: {
              label: `${TRANSLATION_PREFIX}certificateNumber`,
              readOnly: true,
            },
          },
          {
            className: 'col-6',
            type: this.is181 ? 'dict-select' : 'readonly-input',
            wrappers: ['form-field'],
            key: 'compliancePeriod',
            templateOptions: {
              required: true,
              label: `${TRANSLATION_PREFIX}compliancePeriod`,
              readOnly: !this.is181,
              source: this.compliancePeriods$,
            },
          }, {
            className: 'col-6',
            type: this.is181 ? 'input' : 'readonly-input',
            wrappers: ['form-field'],
            key: `quantity${!this.is181 ? '_copy' : ''}`,
            templateOptions: {
              required: this.is181,
              label: `${TRANSLATION_PREFIX}obligation`,
              readOnly: !this.is181,
              keypress: (field, event) => {
                if (isNaN(parseInt(event.key, 10))) {
                  event.preventDefault();
                }
              },
              change: (field, $event) => {
                this.unitManagementService.validateQuantity(field);
              },
            },
            validators: {
              quantity: {
                expression: c => !(isNaN(c.value) || c.value % 1 !== 0 || +c.value <= 0),
                message: () => this.translate.instant('COMMON.messageSection.quantityMustBePositiveNumber'),
              },
            },
          },
          {
            className: 'col-6',
            type: 'app-formly-datepicker',
            wrappers: ['form-field'],
            key: 'regularRateDeadline',
            templateOptions: {
              label: `${TRANSLATION_PREFIX}regularRateDeadline`,
              required: true,
              minDate: moment().local().toDate(),
            },
          },
          {
            className: 'col-6',
            type: this.is181 ? 'dict-select' : 'readonly-input',
            wrappers: ['form-field'],
            key: 'issuanceYear',
            templateOptions: {
              required: true,
              label: `${TRANSLATION_PREFIX}issuanceYear`,
              readOnly: !this.is181,
              source: this.compliancePeriods$,
            },
          },
          {
            className: 'col-12',
            type: 'textarea',
            key: 'adminRemark',
            templateOptions: {
              label: `${TRANSLATION_PREFIX}adminRemarksLabel`,
              rows: 4,
            },
          },
          {
            className: 'col-6',
            type: 'checkbox',
            key: 'discloseComment',
           // hideExpression: !user.hasPermission(PERMISSION_DISCLOSE_COMMENTS),
            templateOptions: {
              label: `${TRANSLATION_PREFIX}discloseRemarksLabel`,
            },
          },
        ],
      },
    ];
  } else {
    this.section181FormFields = [
      {
        fieldGroupClassName: 'row',
        fieldGroup: [
          {
            className: 'col-6',
            type:  'dict-select' ,
            wrappers: ['form-field'],
            key: 'accountId',
            hideExpression: !this.is181,
            templateOptions: {
              label: `${TRANSLATION_PREFIX}facilityName`,
              required: true,
              source: this.getObpsFacilityNames(),
              change: (field, $event) => {
                if (!$event.initial) {
                  this.remittanceData = {
                    ...field.model,
                    accountId: $event ? $event.id : '',
                    certificateNumber: $event ? $event.certificateNumber : '',
                    projectId: '',
                    projectProjectId: '',
                  };
                }
                if($event.id)
                this.getProjectNames($event.id);
              },
            },
          },
          {
            className: 'col-6',
            type: 'readonly-input',
            wrappers: ['form-field'],
            key: 'accountId',
            templateOptions: {
              label: `${TRANSLATION_PREFIX}accountId`,
              readOnly: true,
            },
          },
          {
            className: 'col-6',
            type:  'dict-select' ,
            wrappers: ['form-field'],
            key: 'projectId',
            hideExpression: !this.is181,
            templateOptions: {
              label: `${TRANSLATION_PREFIX}projectName`,
              required: true,
              source: this.getOffsetProjectNames(),
              change: (field, $event) => {
                if( $event && $event.code){
                  this.remittanceData = {
                    ...field.model,
                    projectId:  $event.id,
                    projectProjectId: $event.code,
                    accountId:  $event.accountId,
                  };
                }
              },
            },
          },
          {
            className: 'col-6',
            type: 'readonly-input',
            wrappers: ['form-field'],
            key: 'projectProjectId',
            templateOptions: {
              label: `${TRANSLATION_PREFIX}projectID`,
              readOnly: true,
            },
          },
          {
            className: 'col-6',
            type: this.is181 ? 'app-formly-datepicker' : 'readonly-input',
            wrappers: ['form-field'],
            key: 'reportingPeriodStartDate',
            templateOptions: {
              required: false,
              label: `${TRANSLATION_PREFIX}reportingPeriodStartDate`,
              readOnly: !this.is181,
            },
          },
          {
            className: 'col-6',
            type: this.is181 ? 'app-formly-datepicker' : 'readonly-input',
            wrappers: ['form-field'],
            key: 'reportingPeriodEndDate',
            templateOptions: {
              required: false,
              label: `${TRANSLATION_PREFIX}reportingPeriodEndDate`,
              readOnly: !this.is181,
            },
          },
          {
            className: 'col-6',
            type: this.is181 ? 'input' : 'readonly-input',
            wrappers: ['form-field'],
            key: `quantity${!this.is181 ? '_copy' : ''}`,
            templateOptions: {
              required: this.is181,
              label: `${TRANSLATION_PREFIX}obligation`,
              readOnly: !this.is181,
              keypress: (field, event) => {
                if (isNaN(parseInt(event.key, 10))) {
                  event.preventDefault();
                }
              },
              change: (field, $event) => {
                this.unitManagementService.validateQuantity(field);
              },
            },
            validators: {
              quantity: {
                expression: c => this.is181 ? !(isNaN(c.value) || c.value % 1 !== 0 || +c.value <= 0) : true,
                message: () => this.translate.instant('COMMON.messageSection.quantityMustBePositiveNumber'),
              },
            },
          },
          {
            className: 'col-6',
            type: 'app-formly-datepicker',
            wrappers: ['form-field'],
            key: 'regularRateDeadline',
            templateOptions: {
              label: `${TRANSLATION_PREFIX}regularRateDeadline`,
              required: true,
              minDate: moment().local().toDate(),
            },
          },
          {
            className: 'col-6',
            type:  'dict-select' ,
            wrappers: ['form-field'],
            key: 'reason',
            hideExpression: !this.is181,
            templateOptions: {
              translatePrefix: 'COMMON.obligationReasonList',
              translateOptions: true,
              placeholder: 'selectItem',
              label: `${TRANSLATION_PREFIX}reasonForObligation`,
              required: true,
              source: this.lookupService.getObligationReasonType(),
            },
          },
          {
            className: 'col-6',
            type: this.is181 ? 'dict-select' : 'readonly-input',
            wrappers: ['form-field'],
            key: 'issuanceYear',
            templateOptions: {
              required: true,
              label: `${TRANSLATION_PREFIX}issuanceYear`,
              readOnly: !this.is181,
              source: this.compliancePeriods$,
            },
          },
          {
            className: 'col-12',
            type: 'textarea',
            key: 'reasonComment',
            templateOptions: {
              label: `${TRANSLATION_PREFIX}reasonComment`,
              rows: 4,
              required: true,
            },
            hideExpression: (model) => {
              return model.reason != 'OTHER'
            }
          },
          {
            className: 'col-12',
            type: 'textarea',
            key: 'adminRemark',
            templateOptions: {
              label: `${TRANSLATION_PREFIX}adminRemarksLabel`,
              rows: 4,
            },
          },
          {
            className: 'col-6',
            type: 'checkbox',
            key: 'discloseComment',
           // hideExpression: !user.hasPermission(PERMISSION_DISCLOSE_COMMENTS),
            templateOptions: {
              label: `${TRANSLATION_PREFIX}discloseRemarksLabel`,
            },
          },
          {
            className: 'col-12',
            type: 'textarea',
            key: 'internalAdminRemark',
            templateOptions: {
              label: `${TRANSLATION_PREFIX}internalAdminRemarksLabel`,
              rows: 4,
            },
          },
        ],
      },
    ];
  }
  }

 submit() {

   if (this.remittanceData && this.remittanceData.regularRateDeadline) {
    this.remittanceData.regularRateDeadline =
    moment(this.remittanceData.regularRateDeadline).format(DATE_FORMAT).toString();
  }

   const payload = this.getSubmissionPayload();
   const uri = this.is181 ? '/credits/assign181Obligation' : '/remittanceAction/doRuInvalid';
   const form = this.is181 ? this.section181Form : this.remittanceForm;

   this.submitConfirmation(uri, 'submit', form, payload, '/obligation-management/recognized-units');
 }

 private markFormGroupDirty(formGroup: FormGroup) {
  (Object as any).values(formGroup.controls).forEach(control => {
    control.markAsDirty();

    if (control.controls) {
      this.markFormGroupDirty(control);
    }
  });
}

getFacilityNames() {
  const isObps = this.store.user.isOBPS();
  this.lookupService
    .getFacilityNames()
    .pipe(takeUntil(this._destroy$))
    .subscribe(value => this.obpsAccounts.next(value.filter( a => filterAccount(a))));

  function filterAccount(a: IApp.IFacilityNamesLookup): unknown {
    return  isObps ? a.certificateNumber != null : a;
  }
}

getProjectNames(id) {
  this.lookupService
    .getOffsetProjectNames(id)
    .pipe(takeUntil(this._destroy$))
    .subscribe(value => this.searchOffsetProjectNames.next(value));

}

getObpsFacilityNames(): Observable<IApp.IFacilityNamesLookup[]> {
  return this.obpsAccounts.pipe(filter(val => val != null));
}

getOffsetProjectNames(): Observable<IApp.IFacilityNamesLookup[]> {
  return this.searchOffsetProjectNames.pipe(filter(val => val != null));
}

getSubmissionPayload() {
  let creditBlockList: any;

  if (this.is181) {
    creditBlockList = [{
      unitId: null,
      quantity: this.remittanceData.quantity,
    }];
  } else {
    creditBlockList = [{
      unitId: this.remittanceData.id,
      quantity: this.remittanceData.quantity,
    }];
  }

  let regularRateDeadline = this.remittanceData.regularRateDeadline;
  if (this.remittanceData.regularRateDeadline) {
    regularRateDeadline = moment(
      this.remittanceData.regularRateDeadline,
    )
      .format(DATE_FORMAT)
      .toString();
  }

  let reportingPeriodEndDate = null;
  if (this.remittanceData.reportingPeriodEndDate) {
    reportingPeriodEndDate = moment(
      this.remittanceData.reportingPeriodEndDate,
    )
      .format(DATE_FORMAT)
      .toString();
  }

  let reportingPeriodStartDate = null;
  let complianceYear = this.remittanceData.compliancePeriod;
  if (this.remittanceData.reportingPeriodStartDate) {
    reportingPeriodStartDate = moment(
      this.remittanceData.reportingPeriodStartDate,
    )
      .format(DATE_FORMAT)
      .toString();

 }

  if(this.remittanceData.reason){
    complianceYear = new Date().getFullYear();
  }

  return {
    discloseComment : this.remittanceData.discloseComment,
    adminRemark: this.remittanceData.adminRemark,
    regularRateDeadline,
    creditBlockList,
    accountId: this.remittanceData.accountId,
    complianceYear,
    standardId: this.store.user.programId,
    internalAdminRemark : this.remittanceData.internalAdminRemark,
    reason: this.remittanceData.reason,
    reasonComment: this.remittanceData.reasonComment,
    reportingPeriodEndDate,
    reportingPeriodStartDate,
    projectId: this.remittanceData.projectId,
    issuanceYear: this.remittanceData.issuanceYear
   };
}
setButtons(): void {
  if (this.isNew()) {
    this.setButtonsByActions();
  }
}

setButtonsByActions(): void {

  if (this.remittanceData && this.remittanceData.entityActionList) {
  const entityActionList = this.remittanceData.entityActionList;
  const buttonMap =  actionButtonMap;
  this.buttons = [];
  let noActions = true;
  let editButton;
  for (let i = 0; i < entityActionList.length; i++) {
    const action = entityActionList[i].workflowAction;
    const button = buttonMap[entityActionList[i].workflowAction];

    if (button) {
      if (action === 'EDIT' ) {
        editButton = button;
      } else {
       noActions = false;
       this.buttons.push(button);
      }
    }
  }

  if (noActions && editButton) {
    this.buttons.push(editButton);
  }
}
}

showButton(button: IApp.ICreditButtonConfig) {
  let show = this.isNew() ? button.showOnNew : !button.showOnNew;

  if (show && button.permission) {
    show = show && this.store.user.hasPermission(button.permission);
  }
  return show;
}

isNew() {
  if (this.is181) {
    return false;
  }
  return true;
}

 submitConfirmation(uri: string, label: string, form: FormGroup, model: any, backUri: string): void {
  this.markFormGroupDirty(this.section181Form);
  this.markFormGroupDirty(this.remittanceForm);
  if (this.remittanceForm.valid && this.section181Form.valid) {
      this.modalService
        .open(
          ServiceMessageComponent,
          {
            messages: null,
            message: 'confirmationMessage',
            metaData: this.translate.instant(label),
            type: SereviceMessageType.WARNING,
          },
          true,
          DEFAULT_DIALOG_CONFIG,
        )
        .afterClosed()
        .subscribe((result?: any) => {
          if (result) {
            this.executeAction(uri, form, model, backUri);
          }
        });
  }
}

executeReviewActions(button): void {
  this.modalService
    .open(
      ServiceMessageComponent,
      {
        messages: null,
        message: 'confirmationMessage',
        metaData: button.workflowAction,
        type: SereviceMessageType.WARNING,
      },
      true,
      DEFAULT_DIALOG_CONFIG,
    )
    .afterClosed()
    .subscribe((result?: any) => {
      if (result) {
        this.executeBackendAction(button.workflowAction , button.actionUri);
      }
     // this.resetSelection();
    });
}

public executeBackendAction(value: IApp.IEntityAction, uri: string): void {

let creditActionData: IApp.ICreditActionData = {};
// if(value === 'RESUBMIT' || value === 'SUBMIT'){
creditActionData = this.getSubmissionPayload();
// }
creditActionData.obligationId = this.remittanceData.obligationId;
this.doAction(uri , creditActionData );
}

doAction(uri: string, creditActionData: IApp.ICreditActionData) {
this.obligationManagementService
  .doAction(`/credits${uri}`, creditActionData)
  .pipe(takeUntil(this._destroy$))
  .subscribe(value => {
    this._location.back();
  });
}

executeAction(uri: string, form: FormGroup, model: any, backUri: string) {

   this.obligationManagementService.doAction( uri, model).subscribe(result => {
      this._location.back();
    },
    (error: HttpErrorResponse ) => {
      error.error.fieldMessages = error.error.fieldMessages.map(p =>
        p.field === 'creditBlockList.0.quantity'
          ? { ...p, field: 'quantity' }
          : p,
      );
      this.formService.parseErrors(this.remittanceForm, error.error);
      this.formService.parseErrors(this.section181Form, error.error);
    },
  );
}

}
